// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"preview_wrapper__3Au4R","content":"preview_content__Zinsu","preview":"preview_preview__1gYLv","mobileContainar":"preview_mobileContainar__1aYRM"};